if (!customElements.get("flash-sale")) {
    class FlashSale extends HTMLElement {
      connectedCallback() {
        this._position   = this.dataset.position || "right";
        this._shownKey   = `flash_sale_shown_${this.id}`;
        this._autoSlide  = this.dataset.autoSlide !== "false";
        this._interval   = parseInt(this.dataset.slideInterval || "3", 10) * 1000;
        this._current    = 0;
        this._slideTimer = null;
  
        if (this._position === "left") this.classList.add("fs-pos-left");
  
        const showOnce = this.dataset.showOnce === "true";
        if (showOnce && sessionStorage.getItem(this._shownKey)) return;
  
        const delay = Math.max(0, parseInt(this.dataset.delay || "1", 10)) * 1000;
        setTimeout(() => this._open(), delay);
  
        this.querySelector(".flash-sale-close")?.addEventListener("click", () => this._close());
        document.addEventListener("keydown", (e) => { if (e.key === "Escape") this._close(); });
  
        this._bindNav();
        this._bindAtc();
      }
  
      _open() {
        this._slides = Array.from(this.querySelectorAll(".flash-sale-slide"));
        if (this._slides.length === 0) { this.style.display = "block"; return; }
  
        this._goTo(0);
        this.style.display = "block";
        sessionStorage.setItem(this._shownKey, "1");
  
        if (this._autoSlide && this._slides.length > 1) {
          this._startAutoSlide();
        }
      }
  
      _goTo(index) {
        const slides = this._slides;
        if (!slides || slides.length === 0) return;
  
        slides.forEach((s, i) => s.classList.toggle("active", i === index));
        this._current = index;
  
        const counter = this.querySelector("#fs-current");
        if (counter) counter.textContent = index + 1;
      }
  
      _next() {
        const total = this._slides?.length || 0;
        if (total < 2) return;
        this._goTo((this._current + 1) % total);
      }
  
      _prev() {
        const total = this._slides?.length || 0;
        if (total < 2) return;
        this._goTo((this._current - 1 + total) % total);
      }
  
      _startAutoSlide() {
        this._slideTimer = setInterval(() => this._next(), this._interval);
      }
  
      _stopAutoSlide() {
        clearInterval(this._slideTimer);
      }
  
      _bindNav() {
        this.querySelector(".fs-arrow-prev")?.addEventListener("click", () => {
          this._stopAutoSlide();
          this._prev();
          if (this._autoSlide && (this._slides?.length || 0) > 1) this._startAutoSlide();
        });
  
        this.querySelector(".fs-arrow-next")?.addEventListener("click", () => {
          this._stopAutoSlide();
          this._next();
          if (this._autoSlide && (this._slides?.length || 0) > 1) this._startAutoSlide();
        });
      }
  
      _bindAtc() {
        this.querySelectorAll(".flash-sale-atc").forEach((btn) => {
          btn.addEventListener("click", (e) => {
            e.preventDefault();
            const variantId = btn.dataset.variantId;
            if (!variantId || btn.disabled) return;
            this._addToCart(btn, variantId);
          });
        });
      }
  
      async _addToCart(btn, variantId) {
        const original = btn.textContent.trim();
        btn.classList.add("fs-loading");
        btn.textContent = "...";
  
        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
          });
  
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || "cart error");
          }
  
          btn.textContent = "Eklendi ✓";
          btn.classList.remove("fs-loading");
  
          // Tema kendi cart event'ini dinliyor, sadece bunu dispatch ediyoruz
          fetch("/cart.js")
            .then((r) => r.json())
            .then((cart) => {
              // Tema JS'inin dinlediği standart event - cart-icon-bubble fetch YOK
              document.dispatchEvent(
                new CustomEvent("cart:updated", { detail: { cart }, bubbles: true })
              );
  
              // Züber teması [data-js-cart-count] kullanıyor (tema JS'inden alındı)
              document.querySelectorAll("[data-js-cart-count]").forEach((el) => {
                el.textContent = cart.item_count;
              });
            })
            .catch(() => {});
  
          setTimeout(() => { btn.textContent = original; }, 2000);
        } catch (e) {
          console.error("[flash-sale] ATC error:", e.message);
          btn.textContent = "Hata";
          btn.classList.remove("fs-loading");
          setTimeout(() => { btn.textContent = original; }, 2000);
        }
      }
  
      _close() {
        this._stopAutoSlide();
        this.classList.add("closing");
        setTimeout(() => {
          this.style.display = "none";
          this.classList.remove("closing");
        }, 350);
      }
    }
  
    customElements.define("flash-sale", FlashSale);
  }